<!-- <p>action-edits works!</p> -->
<app-dialog-header headerIcon="history" headerText="Action Edit History"
    (onCloseClick)="onCancelClick()"></app-dialog-header>
<div class="main-div">
    <div class="action-edit-item">
        <span>Changed Properties</span>
        <span>Changed By</span>
    </div>
    <div class="listbox-container">
        <ejs-listbox [dataSource]='actionEdits' [fields]="fields">
            <ng-template #itemTemplate let-data>
                <div class="action-edit-item ejs-listbox-item">
                    <div>
                        <div class="changed-properties" style="font-weight: bolder;">
                            <span>Property Name</span>
                            <span>Previous Value</span>
                            <span>New Value</span>
                        </div>
                        <div class="changed-properties" *ngFor="let prop of getChangedPropeties(data)">
                            <span>{{prop.name}}</span>
                            <span>{{prop.old}}</span>
                            <span>{{prop.new}}</span>
                        </div>
                    </div>
                    <span>{{data.UserID}}</span>
                    <span>{{convertEpoch(data.TimeStamp)}}</span>
                </div>
            </ng-template>
        </ejs-listbox>
    </div>
</div>